<script setup>
import { InitApp, themeOverrides } from '~/utils/initApp'
import { useDefaultSeo } from '~/hooks/seo'
import { useRtl } from '~/hooks'
import { unstableInputRtl, unstableScrollbarRtl, unstableStepsRtl } from 'naive-ui'

InitApp()
useDefaultSeo()
const { locale } = useI18n()
const { isRtl } = useRtl()
</script>

<template>
  <Html
    :lang="locale"
    :dir="isRtl ? 'rtl' : 'ltr'"
    :theme="$route.meta.theme === 'dark' ? 'dark' : 'light'"
    class="h-screen"
  >
    <Body
      class="h-screen overflow-hidden text-sm antialiased text-textPrimary"
      :dir="isRtl ? 'rtl' : 'ltr'"
    >
      <n-config-provider preflight-style-disabled :theme-overrides="themeOverrides" :rtl="isRtl ? [unstableStepsRtl, unstableScrollbarRtl] : []">
        <n-message-provider>
          <NuxtLayout>
            <NuxtPage />
            <common-message-handler />
          </NuxtLayout>
        </n-message-provider>
      </n-config-provider>
    </Body>
  </Html>
</template>
